import { createAction } from '@ngrx/store';
import { withGenesysCloudStoreNameSpace } from '../../common/action-namespace';

const withNameSpace = withGenesysCloudStoreNameSpace('Desktop Notifications');

export const initializeModule = createAction(
  withNameSpace('Initialize module')
);
